import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import CompanyDetails from "../CompanyDetails/CompanyDetails";
import LocationsTable from "../LocationsTable/LocationsTable";
import Panel from "../../atomic/Panel/Panel";
import { Route, Switch, useParams, Redirect } from "react-router-dom";
import EditLocation from "../EditLocation/EditLocation";
import { FileUploadEdit } from "../../atomic/InputEdit/InputEdit";
import { saveLocationAction, isSaving } from "../../../state/data";
import { Link } from "react-router-dom";
import Loader from "../../atomic/Loader/Loader";
import Button from "../../atomic/Button/Button";
import { getCurrentSite } from "../../../lib/helpers";

export function generateId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const ErrorDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
`;

const ConfirmDiv = styled.div`
  width: 100%;
`;
const Buttons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const Divider = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DeleteLocation = () => {
  const { locationId } = useParams();
  const [requireRedirect, setRequireRedirect] = useState(false);
  const dispatch = useDispatch();
  const saving = useSelector(isSaving);
  useEffect(() => {
    if (saving) {
      setRequireRedirect(true);
    }
  }, [saving]);
  if (!saving && requireRedirect) {
    return <Redirect to="/company" />;
  }
  if (saving) {
    return <Loader />;
  }
  return (
    <ConfirmDiv>
      <div>Are you sure you want to delete the location?</div>
      <Buttons>
        <Link to="/company">
          <Button>Cancel</Button>
        </Link>
        <Button
          inverted
          onClick={() =>
            dispatch(saveLocationAction({ id: locationId, status: "deleted" }))
          }
        >
          Delete
        </Button>
      </Buttons>
    </ConfirmDiv>
  );
};

const RegisterCompany = withTheme(
  ({ company, save, saving, locations, theme }) => {
    const [name, setName] = useState(company.name || "");
    const [description, setDescription] = useState(company.description || "");
    const [website, setWebsite] = useState(company.website || "");
    const [email, setEmail] = useState(company.email || "");
    const [category, setCategory] = useState(company.category || "");

    const makeCompany = description => {
      return { ...company, name, description, website, category, email };
    };
    const newLocId = generateId();
    return (
      <React.Fragment>
        <FileUploadEdit
          label="Cover image"
          addLabel=""
          folder={getCurrentSite() + "/companies/" + company.id}
          canEdit={true}
          help="Upload a cover image."
          image={
            (company.image && company.image.url) ||
            "https://storage.googleapis.com/kids-qualitytime.appspot.com/Test-Store-11b9cd48-22c5-4ee7-8d45-b0d37c4e628a/1571700866088"
          }
          onUpload={(url, width, height, contentType) =>
            save({ ...company, image: { url, width, height, contentType } })
          }
          id={"edit-company-image"}
        />
        <CompanyDetails
          name={name}
          setName={setName}
          description={description}
          website={website}
          setWebsite={setWebsite}
          category={category}
          setCategory={setCategory}
          email={email}
          setEmail={setEmail}
          setDescription={setDescription}
          save={description => save(makeCompany(description))}
          saving={saving}
        />
        <Divider>
          <h3>Locations</h3>
          <Link to={"/company/edit/" + newLocId}>
            <Button>
              <FontAwesomeIcon
                icon={["fas", "plus"]}
                size="1x"
                color={theme.color2}
              />{" "}
              Add
            </Button>
          </Link>
        </Divider>
        <Panel>
          <Switch>
            <Route path="/company" exact>
              <LocationsTable locations={locations} />
            </Route>
            <Route path="/company/edit/:locationId">
              <EditLocation locations={locations} />
            </Route>
            <Route path="/company/delete/:locationId">
              <DeleteLocation />
            </Route>
          </Switch>
        </Panel>
      </React.Fragment>
    );
  }
);

export default RegisterCompany;
